"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberStepper = exports.decrement = exports.increment = exports.parseToNumericString = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _fieldUtils = require("./microFields/fieldUtils");

var _fieldAttrsUtils = require("./microFields/fieldAttrsUtils");

var _InputGroupSmall = require("./InputGroupSmall");

var _NumberControl = require("./NumberControl");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Parse the provided value from a number (including zero integers) to a string.
 *      If the number is less than the minValue, returns a string version of the minValue.
 *      If there is a problem converting the number, returns defaultValue.
 *
 * @param {number|string} value - the numeric value to convert to string
 * @param {number|string} minValue - the minimum allowed numeric value
 * @param {number|string} [maxValue=Infinity] - the maximum allowed numeric value
 * @param {string} [defaultValue=''] - the value to return if the provided value cannot be converted to a string
 * @param {function} [normalizedValue=null] - a function for normalizing the value
 * @return {string} the string value of the number or the defaultValue
 */
// eslint-disable-next-line complexity
var parseToNumericString = function parseToNumericString(value, minValue) {
  var maxValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
  var defaultValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var normalizeValue = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  if (value === null || typeof value === 'undefined') return defaultValue;
  var normalizedValue = normalizeValue ? normalizeValue(value) : value;
  var numericValue = parseFloat(normalizedValue);
  var numericMinValue = parseFloat(minValue);
  var numericMaxValue = parseFloat(maxValue); // return the default if either value or minValue are not valid integers

  if (isNaN(numericValue) || isNaN(numericMinValue) || isNaN(numericMaxValue)) return defaultValue; // return the converted value unless it's less than the minValue or greater than the maxValue
  // otherwise return the converted minValue

  if (numericValue < numericMinValue || numericValue > numericMaxValue) {
    return numericValue > numericMaxValue ? numericMaxValue.toString() : numericMinValue.toString();
  }

  return numericValue.toString();
};
/**
 * Increment the provided value by the interval.  If max provided the value can only be incremented up to the max.
 *
 * @param {number} value - the value to increment
 * @param {number} interval - the interval by which to increment the value
 * @param {?number} [max] - (optional) maximum the value can be incremented
 * @return {string} the incremented value as a string
 */


exports.parseToNumericString = parseToNumericString;

var increment = function increment(value, interval) {
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return max !== null && value + interval >= max ? max.toString() : (value + interval).toString();
};
/**
 * Decrement the provided value by the interval.  If min provided the value can only be decremented down to the min.
 *
 * @param {number} value - the value to decrement
 * @param {number} interval - the interval by which to decrement the value
 * @param {?number} [min] - (optional) minimum the value can be decremented
 * @return {string} the decremented value as a string
 */


exports.increment = increment;

var decrement = function decrement(value, interval) {
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  return min !== null && value - interval <= min ? min.toString() : (value - interval).toString();
};

exports.decrement = decrement;

var getDefaultNumber = function getDefaultNumber(value, normalizeValue) {
  return parseFloat(normalizeValue ? normalizeValue(value) : value) || 0;
}; // fall back to zero if the value can't be parsed


var NumberStepper = function NumberStepper(_ref) {
  var name = _ref.name,
      value = _ref.value,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      atts = _ref.atts,
      label = _ref.label,
      helper = _ref.helper,
      incLabel = _ref.incLabel,
      decLabel = _ref.decLabel,
      isRequiredField = _ref.isRequiredField,
      cashbotName = _ref.cashbotName,
      isInvalid = _ref.isInvalid,
      isTouched = _ref.isTouched,
      warningMessage = _ref.warningMessage,
      errorMessage = _ref.errorMessage,
      minValue = _ref.minValue,
      maxValue = _ref.maxValue,
      formatValue = _ref.formatValue,
      usePlusMinus = _ref.usePlusMinus,
      incValue = _ref.incValue,
      light = _ref.light,
      prefix = _ref.prefix,
      suffix = _ref.suffix,
      hiddenLabel = _ref.hiddenLabel,
      hiddenHelper = _ref.hiddenHelper,
      normalizeValue = _ref.normalizeValue,
      ariaPlaceHolder = _ref.ariaPlaceHolder;
  var defaultNumber = getDefaultNumber(value, normalizeValue);
  var minNumber = parseFloat(minValue);
  var maxNumber = parseFloat(maxValue);

  var handleOnChange = function handleOnChange(event) {
    if (_typeof(event) === 'object' && event.target) {
      // using a default of empty string to allow the field to temporarily be empty
      // so users can clear it before they type in a new value
      var updatedValue = normalizeValue ? normalizeValue(event.target.value) : event.target.value;
      onChange(updatedValue);
    }
  };

  var handleOnBlur = function handleOnBlur(event) {
    if (_typeof(event) === 'object' && event.target) {
      // using a default of the minValue to dump the minValue into the field if the field loses focus while empty
      var parsedValue = parseToNumericString(event.target.value, minNumber, maxNumber, minNumber.toString(), normalizeValue);
      var updatedValue = formatValue ? formatValue(parsedValue) : parsedValue;
      onBlur(updatedValue);
    }
  };

  var handleIncrement = function handleIncrement() {
    onChange(increment(defaultNumber, incValue, maxNumber));
  };

  var handleDecrement = function handleDecrement() {
    onChange(decrement(defaultNumber, incValue, minNumber));
  };
  /**
   * Per the WAI ARIA SpinButton Design Pattern the following interaction is supported:
   * (https://www.w3.org/TR/wai-aria-practices-1.1/#spinbutton)
   *
   * Up Arrow: Increases the value.
   * Down Arrow: Decreases the value.
   * Home: If the spinbutton has a minimum value, sets the value to its minimum.
   * End: If the spinbutton has a maximum value, sets the value to its maximum.
   */


  var handleKeydown = function handleKeydown(e) {
    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        handleIncrement();
        break;

      case 'ArrowDown':
        e.preventDefault();
        handleDecrement();
        break;

      case 'Home':
        e.preventDefault();

        if (!isNaN(minNumber)) {
          onChange(minNumber);
        }

        break;

      case 'End':
        e.preventDefault();

        if (!isNaN(maxNumber) && maxNumber !== Infinity) {
          onChange(maxNumber);
        }

        break;

      default:
        break;
    }
  };

  var fieldIds = (0, _fieldUtils.getAllFieldElementIds)(name);
  var inputAttrs = (0, _fieldAttrsUtils.inputAttributes)({
    fieldName: name,
    atts: atts,
    label: label,
    helper: helper,
    isRequiredField: isRequiredField,
    isInvalid: isInvalid
  }); // Make sure the prefix and and/or suffix is read along with the value by screen readers

  if (prefix || suffix) {
    inputAttrs['aria-label'] = "".concat(prefix || '').concat(value).concat(suffix || '');
    inputAttrs['aria-labelledby'] += " ".concat(inputAttrs.id);
  }

  var inputProps = _objectSpread({}, inputAttrs, {
    value: value,
    onBlur: handleOnBlur,
    onChange: handleOnChange
  });

  var inputGroupProps = {
    fieldName: name,
    value: value,
    atts: atts,
    label: label,
    helper: helper,
    cashbotName: cashbotName,
    isInvalid: isInvalid,
    isTouched: isTouched,
    warningMessage: warningMessage,
    errorMessage: errorMessage,
    isRequiredField: isRequiredField,
    showValidationErrors: true,
    hiddenLabel: hiddenLabel,
    hiddenHelper: hiddenHelper
  };
  var baseControlProps = {
    inputId: fieldIds.input.id,
    cashbotName: cashbotName,
    incLabel: incLabel,
    decLabel: decLabel,
    usePlusMinus: usePlusMinus,
    light: light
  };
  return _react.default.createElement(_InputGroupSmall.InputGroupSmall, inputGroupProps, _react.default.createElement("div", {
    className: "stepper-wrapper"
  }, _react.default.createElement(_NumberControl.NumberControl, _extends({}, baseControlProps, {
    type: _NumberControl.CONTROL_TYPE.DECREMENT,
    onClick: handleDecrement
  })), _react.default.createElement("span", {
    className: 'stepper-wrapper__inner'
  }, prefix && _react.default.createElement("span", {
    id: "".concat(name, "-prefix"),
    className: 'currency__prefix',
    "aria-hidden": true
  }, "\xA0", prefix, "\xA0"), _react.default.createElement("input", _extends({}, inputProps, {
    /*
        N.B. the WAI ARIA spinbutton does not work with VoiceOver as it instructs the user to use
        certain keys to increment and decrement the value but then hijacks those key events so that
        we can't implement the functionality.  So hopefully in the future we can use these aria
        attributes but for now we need to roll this widget on our own
    */
    // role="spinbutton"
    // aria-valuenow={value}
    // aria-valuemin={minValue}
    // aria-valuemax={maxValue}
    "aria-live": "polite",
    "aria-relevant": "text",
    "aria-placeholder": ariaPlaceHolder,
    autoComplete: "off",
    tabIndex: "0",
    onKeyDown: handleKeydown
  })), suffix && _react.default.createElement("span", {
    id: "".concat(name, "-suffix"),
    className: 'currency__suffix',
    "aria-hidden": true
  }, "\xA0", suffix, "\xA0")), _react.default.createElement(_NumberControl.NumberControl, _extends({}, baseControlProps, {
    type: _NumberControl.CONTROL_TYPE.INCREMENT,
    onClick: handleIncrement
  }))));
};

exports.NumberStepper = NumberStepper;
NumberStepper.defaultProps = {
  atts: {
    type: 'tel',
    maxLength: 4
  },
  isRequiredField: true,
  isInvalid: false,
  isTouched: false,
  warningMessage: null,
  errorMessage: null,
  minValue: 1,
  maxValue: Infinity,
  formatValue: null,
  usePlusMinus: false,
  incValue: 1,
  light: false,
  prefix: null,
  suffix: null,
  hiddenLabel: false,
  hiddenHelper: false,
  normalizeValue: null,
  ariaPlaceHolder: ''
};
NumberStepper.propTypes = {
  name: _propTypes.default.string.isRequired,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired,
  onChange: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  atts: _propTypes.default.object,
  label: _propTypes.default.string.isRequired,
  helper: _propTypes.default.string.isRequired,
  incLabel: _propTypes.default.string.isRequired,
  decLabel: _propTypes.default.string.isRequired,
  isRequiredField: _propTypes.default.bool,
  cashbotName: _propTypes.default.string.isRequired,
  isInvalid: _propTypes.default.bool,
  isTouched: _propTypes.default.bool,
  warningMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  errorMessage: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  minValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  maxValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  formatValue: _propTypes.default.func,
  usePlusMinus: _propTypes.default.bool,
  incValue: _propTypes.default.number,
  light: _propTypes.default.bool,
  prefix: _propTypes.default.string,
  hiddenLabel: _propTypes.default.bool,
  hiddenHelper: _propTypes.default.bool,
  suffix: _propTypes.default.string,
  normalizeValue: _propTypes.default.func,
  ariaPlaceHolder: _propTypes.default.string
};